<div class="repair-order">
    <div class="repair-order-header auth-card">
        <div class="a-card-header">
            <span>Authorization</span>
        </div>
        <div *ngFor="let logs of pdfAuthHistory; let i = index">
            <div class="auth-info">
                <span> {{logs.dateTime | date: 'MMM d, yyyy'}}: Original estimate was sent (Updated from
                    {{(i == 0 ? logs.roTotal : logs.previousRoTotal) | currency: 'USD'}} to {{logs.roTotal | currency: 'USD'}})</span>
            </div>

            <div class="row m-0 auth-body p-0">
                <div class="w-40 divider-right">
                    <div *ngIf="i !== 0" class="row m-0 divider-bottom">
                        <p class="w-50 my-0 divider-right"
                            [ngClass]="logs.previousRoTotal ? 'previous-ro-title' : 'ro-title-section'">Previous
                            estimate:</p>
                        <div class="w-50 row m-0" [ngClass]="logs.previousRoPDFLink ? 'pdf-link' : ''" (click)="openUrl(logs.previousRoPDFLink)">
                            <p class="my-0" [ngClass]="logs.previousRoTotal ? 'previous-ro-title' : 'ro-title-section'">
                                {{logs.previousRoTotal | currency: 'USD'}}</p>
                            <span class="text" *ngIf="logs.previousRoPDFLink">- Link</span>
                        </div>
                    </div>

                    <div class="row m-0 divider-bottom">
                        <p class="w-50 my-0 divider-right"
                            [ngClass]="i !== 0 ? 'previous-ro-title' : 'ro-title-section'">
                            {{i === 0 ? 'Original estimate:' : 'New estimate:'}}</p>
                        <div class="w-50 row m-0" [ngClass]="logs.roPDFLink ? 'pdf-link' : ''"
                            (click)="openUrl(logs.roPDFLink)">
                            <p class="my-0" [ngClass]="i !== 0 ? 'previous-ro-title' : 'ro-title-section'">
                                {{logs.roTotal | currency: 'USD'}}</p>
                            <span class="text" [ngClass]="i === 0 ? 'pt-23' : ''" *ngIf="logs.roPDFLink">- Link</span>
                        </div>
                    </div>

                    <div class="row m-0">
                        <p class="w-50 my-0 divider-right"
                            [ngClass]="i !== 0 ? 'previous-ro-title' : 'ro-title-section'">Authorized By:
                        </p>
                        <p class="w-50 my-0"
                            [ngClass]="i !== 0 ? 'previous-ro-title' : 'ro-title-section'">
                            {{logs.approvedBy}}</p>
                    </div>
                </div>

                <div class="w-40">
                    <div class="row m-0 divider-right divider-bottom">
                        <p class="w-50 py-2 my-0 divider-right ro-title-section">Date Approved:</p>
                        <p class="w-50 py-2 my-0 ro-title-section">{{logs.dateTime | date: 'MMM d, yyyy'}}</p>
                    </div>

                    <div class="row m-0 divider-right divider-bottom">
                        <p class="w-50 py-2 my-0 divider-right ro-title-section">Time Approved:</p>
                        <p class="w-50 py-2 my-0 ro-title-section">{{logs.dateTime | date: 'h:mm a'}}</p>
                    </div>

                    <div class="row m-0 divider-right divider-bottom">
                        <p class="w-50 py-2 my-0 divider-right ro-title-section">Phone number:</p>
                        <p class="w-50 py-2 my-0 ro-title-section">{{logs.phone | mask: '(000) 000-0000'}}</p>
                    </div>

                    <div class="row m-0 divider-right">
                        <p class="w-50 py-2 my-0 divider-right ro-title-section">Email:</p>
                        <p class="w-50 py-2 my-0 ro-title-section">{{logs.email}}</p>
                    </div>
                </div>

                <div class="w-20">
                    <div class="row m-0 divider-bottom">
                        <span class="py-1 ro-title-section">
                            <app-checkbox inputId="cb-customer-update-person" label="In-Person"
                                [darkGrayCheckbox]="true" [isChecked]="logs.method === 'inPerson' ? true : false"
                                [disabled]="true"></app-checkbox>
                        </span>
                    </div>
                    <div class="row m-0 divider-bottom">
                        <span class="py-1 ro-title-section">
                            <app-checkbox inputId="cb-customer-update-online-portal" label="Online portal"
                                [isChecked]="logs.method === 'online' ? true : false" [disabled]="true"></app-checkbox>
                        </span>
                    </div>
                    <div class="row m-0 divider-bottom">
                        <span class="py-1 ro-title-section">
                            <app-checkbox inputId="cb-customer-update-sms" label="SMS"
                                [isChecked]="logs.method === 'sms' ? true : false" [disabled]="true"></app-checkbox>
                        </span>
                    </div>
                    <div class="row m-0 divider-bottom">
                        <span class="py-1 ro-title-section">
                            <app-checkbox inputId="cb-customer-update-phone" label="Phone"
                                [isChecked]="logs.method === 'phone' ? true : false" [disabled]="true"></app-checkbox>
                        </span>
                    </div>
                    <div class="row m-0">
                        <span class="py-1 ro-title-section">
                            <app-checkbox inputId="cb-customer-update-email" label="Email"
                                [isChecked]="logs.method === 'email' ? true : false" [disabled]="true"></app-checkbox>
                        </span>
                    </div>
                </div>
            </div>

            <div class="auth-description">
                <span> Description: {{logs.description || 'N/A'}}</span>
            </div>
        </div>
    </div>
</div>